import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from '../../services/session'
import CONFIG_COMPANY from "../../services/myConfig";

const AdminApiService = new AdminApi()

const APP_COLOR_KEYS = [
    {key: 'bg', desc: 'boja pozadine aplikacije'},
    {key: 'bb', desc: 'boja pozadine bottom bar-a'},
    {key: 'bb_d', desc: 'boja default ikonice i teksta u bottom baru'},
    {key: 'bb_s', desc: 'boja selected ikonice i teksta u bottom baru'},
    {key: 'ti_bg', desc: 'boja pozadine slot item-a'},
    {key: 'ti_title', desc: 'boja naslova slota'},
    {key: 'ti_desc', desc: 'boja podnaslova slota'},
    {key: 'ti_green', desc: 'boja preostalih mesta na slotu'},
    {key: 'ti_red', desc: 'boja preostalih mesta na slotu'},
    {key: 'ti_yellow', desc: 'boja srednje zute boje za sve'},
    {key: 'ti_filter', desc: 'boja svih filtera u app'},
    {key: 'ti_time_bg', desc: 'boja pozadine vremena na slotu'},
    {key: 'ti_time_color', desc: 'boja texta vremena na slotu'},
    {key: 'ti_bz_bg', desc: 'boja pozadine dugmeta zakazi'},
    {key: 'ti_bz_t', desc: 'boja texta dugmeta zakazi'},
    {key: 'ti_bz_b', desc: 'boja bordera dugmeta zakazi'},
    {key: 'ti_bo_bg', desc: 'boja pozadine dugmeta otkazi'},
    {key: 'ti_bo_b', desc: 'boja bordera dugmeta otkazi'},
    {key: 'ti_bo_t', desc: 'boja texta dugmeta otkazi'},
    {key: 'ti_d_s', desc: 'boja selektovanog datuma na slot strani'},
    {key: 'ti_d_st', desc: 'boja selektovanog datuma - teksta na slot strani'},
    {key: 'ti_d_d', desc: 'boja default datuma na slot strani'},
    {key: 'ti_mt', desc: 'Boja moji treninzi na slot strani'},
    {key: 'ms_1_1', desc: 'prva boja za gradient prve kategorije membership'},
    {key: 'ms_1_2', desc: 'druga boja za gradient prve kategorije membership'},
    {key: 'ms_2_1', desc: 'prva boja za gradient druge kategorije membership'},
    {key: 'ms_2_2', desc: 'druga boja za gradient druge kategorije membership'},
    {key: 'ms_3_1', desc: 'prva boja za gradient trece kategorije membership'},
    {key: 'ms_3_2', desc: 'druga boja za gradient trece kategorije membership'},
    {key: 'tia_bg', desc: 'boja pozadine polja za pregled svih treninga'},
    {key: 'button_primary', desc: 'boja primarnih dugmica u app'},
    {key: 'button_primary_t', desc: 'boja texta primarnih dugmica u app'},
    {key: 'button_buy', desc: 'boja buy dugmica u app'},
    {key: 'button_buy_t', desc: 'boja texta buy dugmica u app'},
    {key: 'member_c_1', desc: 'Prva boja gradienta clanske kartice'},
    {key: 'member_c_2', desc: 'Druga boja gradienta clanske kartice'},
    {key: 'member_c_3', desc: 'Treca boja gradienta clanske kartice'},
    {key: 'member_c_4', desc: 'Boja kvadratica aktivne clanarine'},
    {key: 'btn_wod_bg', desc: 'Boja wod dugmeta floating'},
    {key: 'btn_wod_text', desc: 'Boja texta u wod dugmetu na dnu'},
    {key: 'pt_item_list_text', desc: 'Boja texta u itemu za personalni program'},
    {key: 'pt_item_list_date', desc: 'Boja datuma u itemu za personalni program'},
    {key: 'ms_title', desc: ''},
    {key: 'ms_text_color', desc: ''},
    {key: 'ms_icon', desc: ''},
    {key: 'ms_action_second', desc: ''},
    {key: 'ms_action_first', desc: ''},
    {key: 'ms_action_text', desc: ''},
];


export default {
    data() {
        return {
            id: 0,
            name: '',
            showQrCodeItem: null,
            showColorPanel: false,
            colorPanelItems: [],
            model: {
                priceByUser: 0,
                currentBalance: 0,
                partnerCompanyInfoInvoice: "",
                discount: null,
                priceList: null,
                fixedPrice: null,
                useForInvoiceOnlyActiveMembers: false,
                additionalInvoices: null,

                companyName: '',
                companyAddress: null,
                companyPhone: null,
                companyBusyProgress: null,
                tabs: '',
                showNotificationOnHome: true,
                canAddUserWithTerm: false,
                showConcreteValueForPayment: false,
                userVisibleDays: 1,
                adminVisibleDays: 6,
                hasTerms: true,
                shouldAskToDownloadApps: true,
                googlePlay: null,
                googlePlayByLocation: null,
                appStore: null,
                appStoreByLocation: null,
                huaweiUpdateLink: null,
                huaweiUpdateLinkByLocation: null,
                canExtendPayment: true,
                canAddTrainingType: true,
                trainingTypesCanShowLoyalty: '',
                userCount: 0,
                minutesToCancelTraining: 0,
                companyMail: null,
                fromMail: null,
                limits: null,
                additionalKits: '',
                trainingTypes: '',
                customCategory: '',
                customCategories: '',
                termsAndCondUrl: '',
                reserveTrainingLimits: null,
                maxHourToVisibleSlot: null,
                maxDiffToVisibleSlot: null,
                maxReserveTrainingAsDebtor: 0,
                sendMailKey: null,
                enablePartnersForRegister: true,
                enableVegaReport: true,
                allowToChangeSlotWithUsers: false,
                useQrCode: false,
                showPaymentInvoiceLink: false,
                useProfilePictures: false,
                showRestTrainings: true,
                showRegAlways: false,
                colorsForTrainingTypes: null,
                regVersionToShow: -1,
                qrSymbology: '',
                allowToReserveTrainingAsDebtor: false,
                showTrainerOnSlotToUser: false,
                loyaltyPrograms: null,
                onlyMainAdminCanDeletePayment: false,
                howLongDayBeforeExpireUserCanExtendPayment: 0,
                enableBuyMembership: false,
                enableBuyMembershipByLocation: null,
                busyProgress: 0,
                memberShipCategories: null,
                tabsOnHomePage: '',
                usersCanReserveOnlyForCurrentWeek: false,
                usersCanReserveTrainingWithScanQr: null,
                appHeaderImage: null,
                enablePayWithCreditCards: false,
                enablePayWithIpsQrCode: false,
                enableExploreApp: false,
                appCustomColors: null,
                sugarWodUrl: null,
                appBottomBarItems: null,
                showCheckInBottomBar: false,
                birthdayMessage: null,
                additionalServiceTypes: null,
                timeWhenUserCanSeeSlotsForNextWeek: null,
                enableEntryWithScanQrCodeOnEnterOfGym: null,
                defaultMembershipsVisibleForAll: null,
                shouldUseQrScannerAsEntrance: false,
                chooseLocationOnLogin: null,
                enableShopAndOrder: null,
                enablePersonalProgram: null,
                personalProgramUrl: null,
                personalProgramCompanies: null,
                trainingTypeVisibleDays: null,
                personalBottomBarItems: null,
                canUserSeeTrainingReservation: null,
                personalShouldShowFirst: false,
                urlToAccept: null,
                hiddenActionsWhenExpiredMembership: null,
                showMembershipsAsTab: false,
                recensionUrl: null,
                dismissTypesForFilterByLocation: null,
                useCredits: false,
                useCreditsToBuyForShop: false,
                userCanSeeAllSchedule: false,
                userDoNotHavePermissionToReserve: false,
                sendNotificationToTrainerWhenAddedNewUserToHim: false,
                useTranslations: false,
                setUserCanSeeOnlyOwnSlotAndFreeSlot: false,
                frontUrl: null,
                enableMyDictionary: false,
                adminCanReserveTrainingAlways: false,
                useEntranceAsBusyInGym: null,
                workingHoursForEntrance: null,
                enableOrderReservation: null,
                enableSeeOtherMemberOnSlot: null,
                minutesToReserveTraining: 0,
                alwaysAllowTrainingTypeOnQrEntrance: null,
                useLocationFromComputerOnPultWhenEntrance: false,
                registrationRequiredFields: null,
                registrationHiddenFields: null,
                versionInReviewIOS: 0,
                versionInReviewAndroid: 0,
                versionInReviewHuawei: 0,
                addNumberTrainingsWithNewPaymentWithCurrentState: false,
                shouldUseQrScannerAsTimedSlot: false,
                useFocusForScannerTimedSlot: false,
                userCanSeeOnlySlotsFromMyTrainer: false,
                trainerCanSeeOnlyOwnSlots: false,
                enableSubscriptionModel: false,
                enablePutNotificationForMembership: false,
                resetNumberOfTrainingsIfExpireMembership: false,
                enableMakingBills: false,
                enableSkyPosIntegration: false,
                sendRegistrationEmailWhenAdminCreateUser: false,
                hideMembershipCard: false,
                maxCapacityActiveUsers: null,
                validityCreditInDays: null,
                mandatoryReservedTrainingTypesForEntrance: null,
                firstMembershipTypesForRegistrations: null,
                useSaldoInsteadCreditOnMobileApp: null,
                maxTrainingsPerDayForSameSlot: null,
                hikVisionEnabledLocation: null,
                enableScanAndGetShopItem: null,
                enableChatInApp: null,
            }
        }

    },
    methods: {
        update: update,
        showQrCode: showQrCode,
        showGooglePlay: showGooglePlay,
        showAppStore: showAppStore,
        showHuaweiStore: showHuaweiStore,
        openColorPanel: openColorPanel,
        closeColorPanel: closeColorPanel,
        saveColorPanel: saveColorPanel,
        sanitizeColorItem: sanitizeColorItem,
        updateColorFromPicker: updateColorFromPicker,
        getColorPreviewStyle: getColorPreviewStyle,
        getColorPickerValue: getColorPickerValue,
        isNull: isNull,
        getCompanyConfiguration: getCompanyConfiguration,
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeShowQrCode', () => {
            _self.showQrCodeItem = null;
        });
    },
    beforeMount() {
        if(session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }

        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.getCompanyConfiguration(false)
    }
}

function getCompanyConfiguration(save){
    let _self = this;
    AdminApiService.getCompanyConfiguration(this.name)
        .then((response) => {
            _self.model.priceByUser = _self.isNull(response.data.priceByUser, 0);
            _self.model.currentBalance = _self.isNull(response.data.currentBalance, 0);
            _self.model.partnerCompanyInfoInvoice = _self.isNull(response.data.partnerCompanyInfoInvoice, '');
            _self.model.discount = _self.isNull(response.data.discount, null);
            _self.model.priceList = _self.isNull(response.data.priceList, null);
            _self.model.fixedPrice = _self.isNull(response.data.fixedPrice, null);
            _self.model.useForInvoiceOnlyActiveMembers = _self.isNull(response.data.useForInvoiceOnlyActiveMembers, false);
            _self.model.additionalInvoices = _self.isNull(response.data.additionalInvoices, null);


            _self.model.companyName = _self.isNull(response.data.companyName, '');
            _self.model.companyAddress = _self.isNull(response.data.companyAddress, null);
            _self.model.companyPhone = _self.isNull(response.data.companyPhone, null);
            _self.model.companyBusyProgress = _self.isNull(response.data.companyBusyProgress, null);
            _self.model.tabs = _self.isNull(response.data.tabs, '');
            _self.model.showNotificationOnHome = _self.isNull(response.data.showNotificationOnHome, true);
            _self.model.canAddUserWithTerm = _self.isNull(response.data.canAddUserWithTerm, true);
            _self.model.showConcreteValueForPayment = _self.isNull(response.data.showConcreteValueForPayment, false);
            _self.model.userVisibleDays = _self.isNull(response.data.userVisibleDays, 1);
            _self.model.adminVisibleDays = _self.isNull(response.data.adminVisibleDays, 1);
            _self.model.hasTerms = _self.isNull(response.data.hasTerms, true);
            _self.model.shouldAskToDownloadApps = _self.isNull(response.data.shouldAskToDownloadApps, true);
            _self.model.googlePlay = _self.isNull(response.data.googlePlay, null);
            _self.model.googlePlayByLocation = _self.isNull(response.data.googlePlayByLocation, null);
            _self.model.appStore = _self.isNull(response.data.appStore, null);
            _self.model.appStoreByLocation = _self.isNull(response.data.appStoreByLocation, null);
            _self.model.huaweiUpdateLink = _self.isNull(response.data.huaweiUpdateLink, null);
            _self.model.huaweiUpdateLinkByLocation = _self.isNull(response.data.huaweiUpdateLinkByLocation, null);
            _self.model.canExtendPayment = _self.isNull(response.data.canExtendPayment, true);
            _self.model.canAddTrainingType = _self.isNull(response.data.canAddTrainingType, true);
            _self.model.trainingTypesCanShowLoyalty = _self.isNull(response.data.trainingTypesCanShowLoyalty, '');
            _self.model.userCount = _self.isNull(response.data.userCount, 0);
            _self.model.minutesToCancelTraining = _self.isNull(response.data.minutesToCancelTraining, 0);
            _self.model.companyMail = _self.isNull(response.data.companyMail, null);
            _self.model.fromMail = _self.isNull(response.data.fromMail, null);
            _self.model.limits = _self.isNull(response.data.limits, null);
            _self.model.additionalKits = _self.isNull(response.data.additionalKits, '');
            _self.model.trainingTypes = _self.isNull(response.data.trainingTypes, '');
            _self.model.customCategory = _self.isNull(response.data.customCategory, '');
            _self.model.customCategories = _self.isNull(response.data.customCategories, '');
            _self.model.reserveTrainingLimits = _self.isNull(response.data.reserveTrainingLimits, null);
            _self.model.maxHourToVisibleSlot = _self.isNull(response.data.maxHourToVisibleSlot, null);
            _self.model.maxDiffToVisibleSlot = _self.isNull(response.data.maxDiffToVisibleSlot, null);
            _self.model.maxReserveTrainingAsDebtor = _self.isNull(response.data.maxReserveTrainingAsDebtor, 0);
            _self.model.sendMailKey = _self.isNull(response.data.sendMailKey, null);
            _self.model.enablePartnersForRegister = _self.isNull(response.data.enablePartnersForRegister, true);
            _self.model.enableVegaReport = _self.isNull(response.data.enableVegaReport, true);
            _self.model.allowToChangeSlotWithUsers = _self.isNull(response.data.allowToChangeSlotWithUsers, false);
            _self.model.termsAndCondUrl = _self.isNull(response.data.termsAndCondUrl, '');
            _self.model.useQrCode = _self.isNull(response.data.useQrCode, false);
            _self.model.showPaymentInvoiceLink = _self.isNull(response.data.showPaymentInvoiceLink, false);
            _self.model.useProfilePictures = _self.isNull(response.data.useProfilePictures, false);
            _self.model.showRestTrainings = _self.isNull(response.data.showRestTrainings, true);
            _self.model.colorsForTrainingTypes = _self.isNull(response.data.colorsForTrainingTypes, null);
            _self.model.regVersionToShow = _self.isNull(response.data.regVersionToShow, -1);
            _self.model.showRegAlways = _self.isNull(response.data.showRegAlways, false);
            _self.model.qrSymbology = _self.isNull(response.data.qrSymbology, '');
            _self.model.allowToReserveTrainingAsDebtor = _self.isNull(response.data.allowToReserveTrainingAsDebtor, false);
            _self.model.showTrainerOnSlotToUser = _self.isNull(response.data.showTrainerOnSlotToUser, false);
            _self.model.loyaltyPrograms = _self.isNull(response.data.loyaltyPrograms, null);
            _self.model.onlyMainAdminCanDeletePayment = _self.isNull(response.data.onlyMainAdminCanDeletePayment, false);
            _self.model.howLongDayBeforeExpireUserCanExtendPayment = _self.isNull(response.data.howLongDayBeforeExpireUserCanExtendPayment, 0);
            _self.model.enableBuyMembership = _self.isNull(response.data.enableBuyMembership, false);
            _self.model.busyProgress = _self.isNull(response.data.busyProgress, 0);
            _self.model.memberShipCategories = _self.isNull(response.data.memberShipCategories, null);
            _self.model.tabsOnHomePage = _self.isNull(response.data.tabsOnHomePage, '');
            _self.model.usersCanReserveOnlyForCurrentWeek = _self.isNull(response.data.usersCanReserveOnlyForCurrentWeek, false);
            _self.model.usersCanReserveTrainingWithScanQr = _self.isNull(response.data.usersCanReserveTrainingWithScanQr, null);
            _self.model.appHeaderImage = _self.isNull(response.data.appHeaderImage, null);
            _self.model.enablePayWithCreditCards = _self.isNull(response.data.enablePayWithCreditCards, false);
            _self.model.enablePayWithIpsQrCode = _self.isNull(response.data.enablePayWithIpsQrCode, false);
            _self.model.enableExploreApp = _self.isNull(response.data.enableExploreApp, false);
            _self.model.appCustomColors = _self.isNull(response.data.appCustomColors, null);
            _self.model.sugarWodUrl = _self.isNull(response.data.sugarWodUrl, null);
            _self.model.appBottomBarItems = _self.isNull(response.data.appBottomBarItems, null);
            _self.model.showCheckInBottomBar = _self.isNull(response.data.showCheckInBottomBar, false);
            _self.model.shouldApproveReservedTraining = _self.isNull(response.data.shouldApproveReservedTraining, false);
            _self.model.birthdayMessage = _self.isNull(response.data.birthdayMessage, null);
            _self.model.additionalServiceTypes = _self.isNull(response.data.additionalServiceTypes, null);
            _self.model.timeWhenUserCanSeeSlotsForNextWeek = _self.isNull(response.data.timeWhenUserCanSeeSlotsForNextWeek, null);
            _self.model.enableEntryWithScanQrCodeOnEnterOfGym = _self.isNull(response.data.enableEntryWithScanQrCodeOnEnterOfGym, null);
            _self.model.shouldFilterMembershipByLastOrByGym = _self.isNull(response.data.shouldFilterMembershipByLastOrByGym, null);
            _self.model.defaultMembershipsVisibleForAll = _self.isNull(response.data.defaultMembershipsVisibleForAll, null);
            _self.model.shouldUseQrScannerAsEntrance = _self.isNull(response.data.shouldUseQrScannerAsEntrance, false);
            _self.model.enableBuyMembershipByLocation = _self.isNull(response.data.enableBuyMembershipByLocation, null);
            _self.model.chooseLocationOnLogin = _self.isNull(response.data.chooseLocationOnLogin, null);
            _self.model.enableShopAndOrder = _self.isNull(response.data.enableShopAndOrder, null);
            _self.model.personalProgramUrl = _self.isNull(response.data.personalProgramUrl, null);
            _self.model.enablePersonalProgram = _self.isNull(response.data.enablePersonalProgram, null);
            _self.model.personalProgramCompanies = _self.isNull(response.data.personalProgramCompanies, null);
            _self.model.trainingTypeVisibleDays = _self.isNull(response.data.trainingTypeVisibleDays, null);
            _self.model.personalBottomBarItems = _self.isNull(response.data.personalBottomBarItems, null);
            _self.model.canUserSeeTrainingReservation = _self.isNull(response.data.canUserSeeTrainingReservation, null);
            _self.model.personalShouldShowFirst = _self.isNull(response.data.personalShouldShowFirst, false);
            _self.model.urlToAccept = _self.isNull(response.data.urlToAccept, null);
            _self.model.hiddenActionsWhenExpiredMembership = _self.isNull(response.data.hiddenActionsWhenExpiredMembership, null);
            _self.model.showMembershipsAsTab = _self.isNull(response.data.showMembershipsAsTab, false);
            _self.model.recensionUrl = _self.isNull(response.data.recensionUrl, null);
            _self.model.dismissTypesForFilterByLocation = _self.isNull(response.data.dismissTypesForFilterByLocation, null);
            _self.model.useCredits = _self.isNull(response.data.useCredits, false);
            _self.model.useCreditsToBuyForShop = _self.isNull(response.data.useCreditsToBuyForShop, false);
            _self.model.userCanSeeAllSchedule = _self.isNull(response.data.userCanSeeAllSchedule, false);
            _self.model.userDoNotHavePermissionToReserve = _self.isNull(response.data.userDoNotHavePermissionToReserve, false);
            _self.model.sendNotificationToTrainerWhenAddedNewUserToHim = _self.isNull(response.data.sendNotificationToTrainerWhenAddedNewUserToHim, false);
            _self.model.useTranslations = _self.isNull(response.data.useTranslations, false);
            _self.model.setUserCanSeeOnlyOwnSlotAndFreeSlot = _self.isNull(response.data.setUserCanSeeOnlyOwnSlotAndFreeSlot, false);
            _self.model.frontUrl = _self.isNull(response.data.frontUrl, null);
            _self.model.enableMyDictionary = _self.isNull(response.data.enableMyDictionary, false);
            _self.model.adminCanReserveTrainingAlways = _self.isNull(response.data.adminCanReserveTrainingAlways, false);
            _self.model.useEntranceAsBusyInGym = _self.isNull(response.data.useEntranceAsBusyInGym, null);
            _self.model.workingHoursForEntrance = _self.isNull(response.data.workingHoursForEntrance, null);
            _self.model.enableOrderReservation = _self.isNull(response.data.enableOrderReservation, null);
            _self.model.enableSeeOtherMemberOnSlot = _self.isNull(response.data.enableSeeOtherMemberOnSlot, null);
            _self.model.minutesToReserveTraining = _self.isNull(response.data.minutesToReserveTraining, 0);
            _self.model.alwaysAllowTrainingTypeOnQrEntrance = _self.isNull(response.data.alwaysAllowTrainingTypeOnQrEntrance, null);
            _self.model.useLocationFromComputerOnPultWhenEntrance = _self.isNull(response.data.useLocationFromComputerOnPultWhenEntrance, false);
            _self.model.registrationRequiredFields = _self.isNull(response.data.registrationRequiredFields, null);
            _self.model.registrationHiddenFields = _self.isNull(response.data.registrationHiddenFields, null);
            _self.model.versionInReviewIOS = _self.isNull(response.data.versionInReviewIOS, 0);
            _self.model.versionInReviewAndroid = _self.isNull(response.data.versionInReviewAndroid, 0);
            _self.model.versionInReviewHuawei = _self.isNull(response.data.versionInReviewHuawei, 0);
            _self.model.addNumberTrainingsWithNewPaymentWithCurrentState = _self.isNull(response.data.addNumberTrainingsWithNewPaymentWithCurrentState, false);
            _self.model.shouldUseQrScannerAsTimedSlot = _self.isNull(response.data.shouldUseQrScannerAsTimedSlot, false);
            _self.model.useFocusForScannerTimedSlot = _self.isNull(response.data.useFocusForScannerTimedSlot, false);
            _self.model.userCanSeeOnlySlotsFromMyTrainer = _self.isNull(response.data.userCanSeeOnlySlotsFromMyTrainer, false);
            _self.model.trainerCanSeeOnlyOwnSlots = _self.isNull(response.data.trainerCanSeeOnlyOwnSlots, false);
            _self.model.enableSubscriptionModel = _self.isNull(response.data.enableSubscriptionModel, false);
            _self.model.enablePutNotificationForMembership = _self.isNull(response.data.enablePutNotificationForMembership, false);
            _self.model.resetNumberOfTrainingsIfExpireMembership = _self.isNull(response.data.resetNumberOfTrainingsIfExpireMembership, false);
            _self.model.enableMakingBills = _self.isNull(response.data.enableMakingBills, false);
            _self.model.enableSkyPosIntegration = _self.isNull(response.data.enableSkyPosIntegration, false);
            _self.model.sendRegistrationEmailWhenAdminCreateUser = _self.isNull(response.data.sendRegistrationEmailWhenAdminCreateUser, false);
            _self.model.hideMembershipCard = _self.isNull(response.data.hideMembershipCard, false);
            _self.model.maxCapacityActiveUsers = _self.isNull(response.data.maxCapacityActiveUsers, null);
            _self.model.validityCreditInDays = _self.isNull(response.data.validityCreditInDays, null);
            _self.model.mandatoryReservedTrainingTypesForEntrance = _self.isNull(response.data.mandatoryReservedTrainingTypesForEntrance, null);
            _self.model.firstMembershipTypesForRegistrations = _self.isNull(response.data.firstMembershipTypesForRegistrations, null);
            _self.model.useSaldoInsteadCreditOnMobileApp = _self.isNull(response.data.useSaldoInsteadCreditOnMobileApp, null);
            _self.model.maxTrainingsPerDayForSameSlot = _self.isNull(response.data.maxTrainingsPerDayForSameSlot, null);
            _self.model.hikVisionEnabledLocation = _self.isNull(response.data.hikVisionEnabledLocation, null);
            _self.model.enableScanAndGetShopItem = _self.isNull(response.data.enableScanAndGetShopItem, null);
            _self.model.enableChatInApp = _self.isNull(response.data.enableChatInApp, null);
            if(save){
                session.saveConfig(response.data)
            }
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function isNull(value, def){
    if(value == null) return def
    return value
}

function openColorPanel() {
    const valuesByKey = parseAppCustomColors(this.model.appCustomColors);
    const knownKeys = APP_COLOR_KEYS.map(item => item.key);
    const items = APP_COLOR_KEYS.map(item => {
        return {
            key: item.key,
            desc: item.desc,
            value: valuesByKey[item.key] || ''
        }
    });

    Object.keys(valuesByKey).forEach(key => {
        if (!knownKeys.includes(key)) {
            items.push({
                key: key,
                desc: 'Custom key',
                value: valuesByKey[key]
            })
        }
    });

    this.colorPanelItems = items;
    this.showColorPanel = true;
}

function closeColorPanel() {
    this.showColorPanel = false;
}

function saveColorPanel() {
    this.model.appCustomColors = this.colorPanelItems
        .filter(item => item.value != null && item.value.toString().trim().length > 0)
        .map(item => item.key + '-' + normalizeHex(item.value))
        .join(';');
    this.showColorPanel = false;
}

function sanitizeColorItem(item) {
    item.value = normalizeHex(item.value);
}

function updateColorFromPicker(item, value) {
    const pickerValue = normalizeHex(value);
    const currentValue = normalizeHex(item.value);
    item.value = currentValue.length === 8 ? pickerValue + currentValue.slice(6, 8) : pickerValue;
}

function getColorPreviewStyle(item) {
    const value = normalizeHex(item.value);
    if (value.length !== 6 && value.length !== 8) {
        return 'background-color: transparent;';
    }
    return 'background-color: #' + value + ';';
}

function getColorPickerValue(item) {
    const value = normalizeHex(item.value);
    if (value.length >= 6) {
        return '#' + value.slice(0, 6);
    }
    return '#000000';
}

function parseAppCustomColors(value) {
    const result = {};
    if (value == null || value.toString().trim().length === 0) {
        return result;
    }

    value.split(';').forEach(item => {
        const trimmedItem = item.trim();
        const separatorIndex = trimmedItem.indexOf('-');
        if (separatorIndex <= 0) return;

        const key = trimmedItem.slice(0, separatorIndex).trim();
        const color = normalizeHex(trimmedItem.slice(separatorIndex + 1));
        if (key.length > 0 && color.length > 0) {
            result[key] = color;
        }
    });

    return result;
}

function normalizeHex(value) {
    if (value == null) return '';
    return value.toString().replace('#', '').replace(/[^0-9a-fA-F]/g, '').toUpperCase();
}


function update() {
    let _self = this;
    AdminApiService.updateConfiguration(this.model)
        .then((response) => {
            swal('Success', 'Konfiguracija ažurirana', 'success')
            _self.getCompanyConfiguration(true)
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function showQrCode(){
    let item = {
        name: this.model.companyName,
        orderUuid: this.model.usersCanReserveTrainingWithScanQr,
    }
    this.showQrCodeItem = item;
}

function showGooglePlay(){
    let item = {
        name: 'Google Play',
        orderUuid: this.model.googlePlay,
    }
    this.showQrCodeItem = item;
}

function showAppStore(){
    let item = {
        name: 'App Store',
        orderUuid: this.model.appStore,
    }
    this.showQrCodeItem = item;
}

function showHuaweiStore(){
    let item = {
        name: 'Huawei Store',
        orderUuid: this.model.huaweiUpdateLink,
    }
    this.showQrCodeItem = item;
}



// WEBPACK FOOTER //
// ./src/components/Company/Configuration.js